export const pathnames = {
  // If all locales use the same pathname, a
  // single external path can be provided.
  "/": "/",

  // If locales use different paths, you can
  // specify each external path per locale.
  "/about": {
    en: "/about",
    sv: "/om-useit",
    no: "/om-useit",
    da: "/om-useit",
  },

  "/contact": {
    en: "/contact",
    sv: "/kontakta-oss",
    no: "/kontakt-oss",
    da: "/kontakt",
  },

  "/services": {
    en: "/services",
    sv: "/vi-erbjuder",
    no: "/vi-tilbyr",
    da: "/vi-tilbyder",
  },

  "/services/[slug]": {
    en: "/services/[slug]",
    sv: "/vi-erbjuder/[slug]",
    no: "/vi-tilbyr/[slug]",
    da: "/vi-tilbyder/[slug]",
  },

  "/services/[slug]/[serviceSlug]": {
    en: "/services/[slug]/[serviceSlug]",
    sv: "/vi-erbjuder/[slug]/[serviceSlug]",
    no: "/vi-tilbyr/[slug]/[serviceSlug]",
    da: "/vi-tilbyder/[slug]/[serviceSlug]",
  },

  "/case": {
    en: "/case",
    sv: "/kundcase",
    no: "/kundecase",
    da: "/kundecase",
  },

  "/case/[slug]": {
    en: "/case/[slug]",
    sv: "/kundcase/[slug]",
    no: "/kundecase/[slug]",
    da: "/kundecase/[slug]",
  },

  "/certificate/[slug]": {
    en: "/certificate/[slug]",
    sv: "/kursintyg/[slug]",
    no: "/kursbevis/[slug]",
    da: "/kursbevis/[slug]",
  },

  "/ecommerce": {
    en: "/ecommerce",
    sv: "/hur-tillganglig-ar-ehandeln-2023",
    no: "/hvor-universelt-utformet-er-ehandelen",
    da: "/ecommerce",
  },

  "/ecommerce/[slug]": {
    en: "/ecommerce/[slug]",
    sv: "/hur-tillganglig-ar-ehandeln-2023/[slug]",
    no: "/hvor-universelt-utformet-er-ehandelen/[slug]",
    da: "/ecommerce/[slug]",
  },

  "/newsletter": {
    en: "/newsletter",
    sv: "/nyhetsbrev",
    no: "/nyhetsbrev",
    da: "/nyhetsbrev",
  },

  "/confirmation": {
    en: "/confirmation",
    sv: "/bekraftelse",
    no: "/bekreftelse",
    da: "/bekraftelse",
  },

  "/posts": {
    en: "/posts",
    sv: "/aktuellt",
    no: "/aktuelt",
    da: "/aktuelt",
  },

  "/posts/[slug]": {
    en: "/posts/[slug]",
    sv: "/aktuellt/[slug]",
    no: "/aktuelt/[slug]",
    da: "/aktuelt/[slug]",
  },

  "/campaigns": {
    en: "/campaigns",
    sv: "/kampanjer",
    no: "/kampanjer",
    da: "/kampanjer",
  },

  "/campaigns/[campaignId]": {
    en: "/campaigns/[campaignId]",
    sv: "/kampanjer/[campaignId]",
    no: "/kampanjer/[campaignId]",
    da: "/kampanjer/[campaignId]",
  },

  "/privacy": {
    en: "/privacy",
    sv: "/integritetspolicy",
    no: "/personvern",
    da: "/privatlivspolitik",
  },

  "/research": {
    en: "/research",
    sv: "/forskning-og-utvikling",
    no: "/forskning-og-utvikling",
    da: "/forskning-og-utvikling",
  },

  "/research/[slug]": {
    en: "/research/[slug]",
    sv: "/forskning-og-utvikling/[slug]",
    no: "/forskning-og-utvikling/[slug]",
    da: "/forskning-og-utvikling/[slug]",
  },
};

export type RouteKey = keyof typeof pathnames;

export type PathnameLocale = "sv" | "no" | "da" | "en";

export const localizedPathname = (
  routeKey: RouteKey,
  locale: PathnameLocale,
): string => {
  const entry = pathnames[routeKey];
  if (typeof entry === "string") return entry;
  return entry[locale] ?? entry.en;
};
